import { default as getRegistrationTemplate } from './registrationTemplate';
const validResponses = ['yes', 'y', 'x', 'no', ''];

export default async (users, uploadedBy) => {

  if(!users || (users && users.length === 0)) return ({ message: 'No user data', validCSV: false });
  // Check for required columns
  const [firstOne] = users;
  debugger;
  let keys = Object.keys(firstOne)
  const validKeys = ["firstName", "lastName", "email", "phone", "city", "state", "postalCode", "regenag-101", "grazing", "cropping", "couponCode", "group"];
  keys = keys.filter(el => validKeys.indexOf(el) === -1)
  if(keys.length > 0){
    return ({ message: 'Invalid columns. Must include: firstName, lastName, email, phone, city, state, postalCode, group, regenag-101, grazing, cropping, couponCode', validCSV: false });
  }
    // !firstOne.firstName || !firstOne.lastName ||
    // !firstOne.email || !firstOne.phone ||
    // !firstOne.city || !firstOne.state ||
    // !firstOne.postalCode || (!firstOne['regenag-101'] || firstOne['regenag-101'] === '') ||
    // (!firstOne.grazing || firstOne.grazing === '') || (!firstOne.cropping || firstOne['cropping'] === '')
    //!firstOne.group || !firstOne.couponCode <= optional columns

  // Check for valid Subscription values in each row
  const invalidSubs = users.filter((user) => (validResponses.indexOf(user['regenag-101']) === -1 || validResponses.indexOf(user.grazing) === -1 || validResponses.indexOf(user.cropping) === -1));
  if(invalidSubs.length) return ({ message: '"subscribed" column must contain either: "yes", "no", or be empty', totalInvalid: invalidSubs.length, invalidSubs, validCSV: false });

  // Convert to JSON friendly format
  const scrubbedUsers = users.map((user) => {
    user.email = user.email.toLowerCase();
    user.password = 'changePassword!'
    user['regenag-101'] = (user['regenag-101'] === 'yes' || user['regenag-101'] === 'y' || user['regenag-101'] === 'x');
    user.grazing = (user.grazing === 'yes' || user.grazing === 'y' || user.grazing === 'x')
    user.cropping = (user.cropping === 'yes' || user.cropping === 'y' || user.cropping === 'x')
    user.registrations = getRegistrationTemplate(user, uploadedBy); // be gentle - any errors, an empty [] is returned
    return user;
  });
  return ({ status: 'success', message: 'bulk invite endpoint hit', data: scrubbedUsers, validCSV: true }); // reqBody: scrubbedUsers,
}